(function () {
    'use strict';
    var controllerId = 'pcModulo2BAdd';
    angular.module('app').controller(controllerId, ['$scope', '$uibModalInstance', 'modulo', 'corsoId', 'opInsert', 'bModSpec', 'bArticolato', 'tFigProfessionali', fn_pcModulo2BAdd]);

    function fn_pcModulo2BAdd($scope, $uibModalInstance, modulo, corsoId, opInsert, bModSpec, bArticolato, tFigProfessionali) {
        $scope.Title = '';
        $scope.bModSpec = bModSpec;
        $scope.bArticolato = bArticolato;
        $scope.tFigProfessionali = tFigProfessionali;
        console.info('tFigProfessionali', tFigProfessionali);

        if (modulo) {
            $scope.record = jQuery.extend({}, modulo); //Clona oggetto.
            $scope.Title = 'Modifica Modulo (ID: ' + $scope.record.Id + ')';
        }
        else {
            $scope.Title = 'Nuovo Modulo';
            $scope.record = {};
            $scope.record.Id = 0;
            $scope.record.CorsoId = corsoId;
            $scope.record.OpInsert = opInsert;
            $scope.record.DtInsert = new Date();
            $scope.record.Deleted = false;
            $scope.record.iVersion = 1;
            $scope.record.M2B_bModuliSpecifici = bModSpec;
        }      

        $scope.change_bSpecifico = function () {
            if (!$scope.record.M2B_bSpecifico) {
                $scope.record.M2B_CNDTFigProfId = '';
            }
        }



        $scope.ok = function (isValid) {
            if (isValid) {
                if (!$scope.record.M2B_bSpecifico) {
                    $scope.record.M2B_CNDTFigProfId = 0;
                }
                var result = addItem($scope.record);
                $uibModalInstance.close(result);
            }
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        function addItem(item) {
            return item;
        }

    }
})();